import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { CuentasPorCobrarService } from '../../../../services/cuentas-por-cobrar.service';
import { ConstantsService } from '../../../../services/constants.service';

declare var moment;

@Component({
  selector: 'app-detalles-convenio',
  templateUrl: './detalles-convenio.component.html',
  styleUrls: ['./detalles-convenio.component.scss']
})
export class DetallesConvenioComponent implements OnInit {
    @Input() editable: boolean = false;
    @Input() cuentasPorCobrar: any [] = [];
    @Input() configuracionGeneral: any = {};
    //Se requiere la información de las rentas para poder copiar/aplicar el convenio de las rentas
    @Input() cuentasRentas: any = null;
    @Input() configuracionRentas: any = null;

    public meses: any=['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
    public ultima_renta_index = 0;
    public ultima_renta_diferidos_index = 0;
    public loading:boolean=false;
    
    //Modelos

    //Helpers
    public fecha_inicio_contrato: string = null;
    public fecha_fin_contrato: string = null;

    constructor(public cuentas_por_cobrar_service:CuentasPorCobrarService, 
        private constant: ConstantsService) { 

    }

    ngOnInit() {
      moment.locale('es');
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.cuentasPorCobrar && this.cuentasPorCobrar.length > 0) {
            let rentas_por_cobrar = this.cuentasPorCobrar;
            let ultimaCuentaPosibleEliminar = 0;

            console.log('#iterando');
            //En caso de que ya se hayan eliminado rentas en otro momento, este loop identifica cúal es la última renta que se elimino
            rentas_por_cobrar.some((cuentaPorCobrar, index) => {
              if(cuentaPorCobrar.deleted === 1){
                ultimaCuentaPosibleEliminar = ( index - 1);
                return true;
              }
              return false;
            });
            
            //Estos indices se utilizan para algunas reglas del funcionamiento del convenio
            if(ultimaCuentaPosibleEliminar === 0){
              this.ultima_renta_index = (rentas_por_cobrar.length -1);
              this.ultima_renta_diferidos_index = this.ultima_renta_index
            }else{
              this.ultima_renta_index = ultimaCuentaPosibleEliminar;
              this.ultima_renta_diferidos_index = ultimaCuentaPosibleEliminar;
            }
        }
    }

  public diferirRenta(renta: any){
    
    if(renta.diferir){
      renta.diferir_control = true;
    }else{
      //Cuando se hace uncheck debemos quitar los elementos seleccionados de la disperción
      renta.diferir_control = false;
      renta.importe = renta.importe;
      renta.importe_diferido = renta.importe_sin_iva;
      renta.diferido_periodos = null;
      renta.diferido_porcentaje = null;
      renta.diferir_skip = null;

      //Recalculamos diferidos para que quiten las disperciones hechas
      this.aplicarDiferidosALasRentas();
    }

  }

  public calcularDiferidoRenta(renta_diferida){
    //Se debe haber seleccionado los tres parámetros para poder aplicar el diferido de un importe. (parcialidades, porcentaje y mes de inicio)
    if(!renta_diferida.diferido_periodos || !renta_diferida.diferido_porcentaje || !renta_diferida.diferir_skip){
      return;
    }    

    if(renta_diferida.diferido_periodos!=undefined && renta_diferida.diferido_periodos>0){
      var rentas_faltantes = this.calcularRentasFaltantes(renta_diferida);
      if(renta_diferida.diferido_periodos>rentas_faltantes){
        renta_diferida.diferido_periodos=renta_diferida.diferido_periodos-1;
        alert("No puedes diferir en más periodos de los que faltan");
      }

      //Armar la tabla de rentas con las configuraciones de los diferidos seleccionados
      this.aplicarDiferidosALasRentas();    
        
    }else{
      //Si no se tiene diferido o es cero, eliminar de la siguiente renta el diferido
      if(renta_diferida.diferido_periodos!=undefined && renta_diferida.diferido_periodos<=0){
        var eliminar_diferidos = false;
        for(var i=0;i<this.cuentasPorCobrar.length;i++){
          var renta_por_cobrar = this.cuentasPorCobrar[i];
          if(eliminar_diferidos){
            renta_por_cobrar.incremento_diferido=0;
          }else if(renta_por_cobrar.id_cuenta_por_cobrar==renta_diferida.id_cuenta_por_cobrar){
            eliminar_diferidos = true;
          }
        }
      }
    }

  }

  public aplicarDiferidosALasRentas(){
    
    //Limpiar. En caso de que se cambie el mes donde se va a diferir, hay que quitar los incrementos que se habían hecho
    for(var i=0;i<this.cuentasPorCobrar.length;i++){
      var renta_por_cobrar = this.cuentasPorCobrar[i];
      renta_por_cobrar.incremento_diferido = null;
    }

    var diferir=false;
    var cantidad_a_diferir = 0;
    var diferido_periodos = undefined;
    var diferido_skip = undefined;
    var diferido_porcentaje = 0;
    var veces_diferido = 0;
    
    for(var i=0;i<this.cuentasPorCobrar.length;i++){
      var renta_por_cobrar = this.cuentasPorCobrar[i];
      if(diferir){
        //Si hay un numero skip, nos saltamos rentas
        if(diferido_skip && diferido_skip!=0){
          diferido_skip = diferido_skip-1;
          continue;
        }
        if(diferido_porcentaje){
          renta_por_cobrar.incremento_diferido = (cantidad_a_diferir*(diferido_porcentaje/100))/diferido_periodos;
        }else{
          renta_por_cobrar.incremento_diferido = cantidad_a_diferir/diferido_periodos;
        }
        veces_diferido++;

        if(veces_diferido >= diferido_periodos){
          diferir = false;
        }
      }else if(renta_por_cobrar.diferir){

        //Se debe haber seleccionado los tres parámetros para poder aplicar el diferido de un importe. (parcialidades, porcentaje y mes de inicio)
        if(!renta_por_cobrar.diferido_periodos || !renta_por_cobrar.diferido_porcentaje || !renta_por_cobrar.diferir_skip){
          return;
        }   

        //A partir de la siguiente renta, comenzamos a diferir
        diferir=true;
        diferido_periodos = renta_por_cobrar.diferido_periodos;
        diferido_porcentaje = renta_por_cobrar.diferido_porcentaje;
        diferido_skip =  renta_por_cobrar.diferir_skip.indice;

        cantidad_a_diferir = parseFloat(renta_por_cobrar.importe_sin_iva);

        let porcentajeADiferir = diferido_porcentaje ? (diferido_porcentaje/100) : 1;
        let montoADiferir = (cantidad_a_diferir * porcentajeADiferir);

        //Decrementamos la cantidad que se va a diferir, ya que esto modifico el importe
        renta_por_cobrar.importe_diferido = renta_por_cobrar.importe_sin_iva - montoADiferir;

        //Se reinicia las veces que debe ser diferido
        veces_diferido = 0;
      } else {
        //En caso de que anteriormente tuviera aplicado algún incremente y se haya quitado este en la nueva configuración de la distribución
        renta_por_cobrar.incremento_diferido = null;
      }
    }
  }

  calcularRentasFaltantes(renta){
    var contar_renta = false;
    var rentas_faltantes = 0;
    for(var i=0;i<this.cuentasPorCobrar.length;i++){
      var renta_por_cobrar = this.cuentasPorCobrar[i];
      if(contar_renta){
        rentas_faltantes++;
      }else if(renta_por_cobrar.id_cuenta_por_cobrar==renta.id_cuenta_por_cobrar){
        contar_renta = true;
      }
    }

    return rentas_faltantes;
  }

  public quitarDeVigencia(renta_por_cobrar){
    renta_por_cobrar.deleted = 1;
  }

  public incluirEnVigencia(renta_por_cobrar){
    renta_por_cobrar.deleted = 0;
  }

  //Devuelve true si 'index' es la ultima renta que sigue vigente (deleted!=1).
  //Se calcula en vivo, asi el boton "Quitar de vigencia" siempre aparece en el mes correcto
  //sin depender de ultima_renta_index (que dependia de ngOnChanges y a veces no se actualizaba).
  public esUltimaVigente(index){
    for(var j = this.cuentasPorCobrar.length - 1; j >= 0; j--){
      if(!this.cuentasPorCobrar[j].deleted || this.cuentasPorCobrar[j].deleted == 0){
        return j === index;
      }
    }
    return false;
  }

  //Devuelve true si 'index' es la primera renta quitada (deleted==1) -> se puede regresar a vigencia.
  public esPrimeraQuitada(index){
    for(var j = 0; j < this.cuentasPorCobrar.length; j++){
      if(this.cuentasPorCobrar[j].deleted == 1){
        return j === index;
      }
    }
    return false;
  }

  compararPeriodos(periodo_1,periodo_2){
    if (periodo_1==null || periodo_2==null) {
      return false;
    }
    return periodo_1.indice===periodo_2.indice;
  }

  public aplicarDescuento(cuenta){
    //Aplicar descuento
    cuenta.importe_descuento = cuenta.importe_sin_iva - (cuenta.importe_sin_iva * (cuenta.descuento/100));
  }

  public aplicarConvenioRenta(){
    //El convenio de renta se aplica, cuando el switch se prendio
    if(!this.configuracionGeneral.copiar_convenio_renta){
      return;
    }
    
    if(this.configuracionRentas.vigencia_contrato){
      this.configuracionGeneral.vigencia_contrato = true;
      this.aplicarVigenciasDeRentas();
    }

    if(this.configuracionRentas.descuento_renta){
      this.configuracionGeneral.descuento_renta = true;
      this.aplicarDescuentosDeRentas();
    }

    if(this.configuracionRentas.diferir_renta){
      this.configuracionGeneral.diferir_renta = true;
      this.aplicarDiferidosDeRentas();
    }
  }
  
  private aplicarVigenciasDeRentas(){
    let rentas = this.cuentasRentas;
    let cuentasPorCobrar = this.cuentasPorCobrar;
    for(let index = 0; index < rentas.length; index++){
      let rentaItem = rentas[index];
      
      //Si no fue eliminada esa cuenta, avanzar al siguiente item (evitar anidación)
      if(!rentaItem.deleted || rentaItem.deleted === 0){
        continue;
      }

      for(let indexCuentas = 0; indexCuentas<cuentasPorCobrar.length; indexCuentas++ ){
        let cuentaItem = cuentasPorCobrar[indexCuentas];
        let fechaInicio = moment(cuentaItem.fecha_para_cobrar,"YYYY-MM-DD HH:mm:ss") ;

        //La fecha fin es la fecha de cobro del próximo perido o si es la última fecha le sumamos un mes 
        //TODO (si la periodicidad es diferente a mensual, el mes debería cambiarse por la unidad correcta)
        let fechaFin = ((indexCuentas +1) < cuentasPorCobrar.length) ? 
        moment(cuentasPorCobrar[(indexCuentas+1)].fecha_para_cobrar,"YYYY-MM-DD HH:mm:ss") : 
        moment(fechaInicio).add(1, 'M');

        //En moment. '[' indica que la fecha incio es inclusiva y ')' indica que la fecha fin es excluyente
        if(moment(rentaItem.fecha_para_cobrar, "YYYY-MM-DD HH:mm:ss").isBetween(fechaInicio, fechaFin, undefined, '[)')){
          cuentaItem.deleted = 1;
        }
      }
      
    }

  }

  private aplicarDescuentosDeRentas(){
    let rentas = this.cuentasRentas;
    let cuentasPorCobrar = this.cuentasPorCobrar;
    for(let index = 0; index < rentas.length; index++){
      let rentaItem = rentas[index];
      
      //Si no fue eliminada esa cuenta, avanzar al siguiente item (evitar anidación)
      if(!rentaItem.descuento || rentaItem.descuento === 0){
        continue;
      }

      for(let indexCuentas = 0; indexCuentas<cuentasPorCobrar.length; indexCuentas++ ){
        let cuentaItem = cuentasPorCobrar[indexCuentas];
        let fechaInicio = moment(cuentaItem.fecha_para_cobrar,"YYYY-MM-DD HH:mm:ss") ;

        //La fecha fin es la fecha de cobro del próximo perido o si es la última fecha le sumamos un mes 
        //TODO (si la periodicidad es diferente a mensual, el mes debería cambiarse por la unidad correcta)
        let fechaFin = ((indexCuentas +1) < cuentasPorCobrar.length) ? 
        moment(cuentasPorCobrar[(indexCuentas+1)].fecha_para_cobrar,"YYYY-MM-DD HH:mm:ss") : 
        moment(fechaInicio).add(1, 'M');

        //En moment. '[' indica que la fecha incio es inclusiva y ')' indica que la fecha fin es excluyente
        if(moment(rentaItem.fecha_para_cobrar, "YYYY-MM-DD HH:mm:ss").isBetween(fechaInicio, fechaFin, undefined, '[)')){
          cuentaItem.descuento = rentaItem.descuento;
          cuentaItem.importe_descuento = cuentaItem.importe_sin_iva - (cuentaItem.importe_sin_iva * (cuentaItem.descuento/100));

        }
      }
      
    }

  }

  private aplicarDiferidosDeRentas(){
    let rentas = this.cuentasRentas;
    let cuentasPorCobrar = this.cuentasPorCobrar;
    for(let index = 0; index < rentas.length; index++){
      let rentaItem = rentas[index];
      
      //Si no fue eliminada esa cuenta, avanzar al siguiente item (evitar anidación)
      if(!rentaItem.diferir){
        continue;
      }

      for(let indexCuentas = 0; indexCuentas<cuentasPorCobrar.length; indexCuentas++ ){
        let cuentaItem = cuentasPorCobrar[indexCuentas];
        let fechaInicio = moment(cuentaItem.fecha_para_cobrar,"YYYY-MM-DD HH:mm:ss") ;

        //La fecha fin es la fecha de cobro del próximo perido o si es la última fecha le sumamos un mes 
        //TODO (si la periodicidad es diferente a mensual, el mes debería cambiarse por la unidad correcta)
        let fechaFin = ((indexCuentas +1) < cuentasPorCobrar.length) ? 
        moment(cuentasPorCobrar[(indexCuentas+1)].fecha_para_cobrar,"YYYY-MM-DD HH:mm:ss") : 
        moment(fechaInicio).add(1, 'M');

        //En moment. '[' indica que la fecha incio es inclusiva y ')' indica que la fecha fin es excluyente
        if(moment(rentaItem.fecha_para_cobrar, "YYYY-MM-DD HH:mm:ss").isBetween(fechaInicio, fechaFin, undefined, '[)')){
          cuentaItem.diferir_control = true;
          cuentaItem.diferir = rentaItem.diferir;
          cuentaItem.diferido_periodos = rentaItem.diferido_periodos;
          cuentaItem.diferido_porcentaje = rentaItem.diferido_porcentaje;
          //TODO: Validar que la cuenta tenga disponible las opciones donde se va a agregar el diferido, 
          //ya que es posible que los servicios tengan menos periodos que las rentas y eso se debería manejora
          cuentaItem.diferir_skip = rentaItem.diferir_skip;
        }
      }
      
    }

    //Actualiza la lista de cuentas diferidas y muestras las etiquetas de los descuentos aplicados
    this.aplicarDiferidosALasRentas();

  }

}


// WEBPACK FOOTER //
// ./src/app/components/contratos/modal-nuevo-convenio/detalles-convenio/detalles-convenio.component.ts